import { styled } from '@mui/material';

export const PaddedContainer = styled('div')({
  padding: '4px 0px 4px 16px',
});
